function debounceFacets(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

document.addEventListener('DOMContentLoaded', function () {
    // $('body').addClass('filters-popup--show');

    // Open and close filter popup
    $(document).on('click', '.js-filters-popup__open', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Show the filter popup
        $('body').addClass('filters-popup--show');

        // Close all accordion contents
        $('.collection-filter__accordion-content')
            .removeClass('is-active')
            .slideUp();
        $('.collection-filter__accordion-header').removeClass('is-active');
    });

    $(document).on('click', '.js-filters-popup__close', function (e) {
        e.preventDefault();
        $('body').removeClass('filters-popup--show');
    });

    $(document).on(
        'click',
        '.filters-popup__overlay, .collection-filter__overlay',
        function (e) {
            $('body').removeClass('filters-popup--show');
        },
    );

    $(document).on('click', '.filters-popup, .collection-filter', function (e) {
        e.stopPropagation();
    });

    // Sync checkboxes between both forms
    $(document).on(
        'change',
        'input[name="filter.p.m.custom.filter_product_type"]',
        function () {
            const value = $(this).val();
            const isChecked = $(this).is(':checked');

            // Update all checkboxes with the same value across both forms
            $(`input[name="filter.p.m.custom.filter_product_type"][value="${value}"]`)
                .not(this)
                .prop('checked', isChecked);

            // Handle "All" filter logic
            if (value === 'all' && isChecked) {
                $('input[name="filter.p.m.custom.filter_product_type"]')
                    .not('[value="all"]')
                    .prop('checked', false);
            } else if (value !== 'all' && isChecked) {
                $(
                    'input[name="filter.p.m.custom.filter_product_type"][value="all"]',
                ).prop('checked', false);
            }
        },
    );

    // Handle "All" filter special case
    $(document).on(
        'change',
        'input[value="all"][name="filter.p.m.custom.filter_product_type"]',
        function () {
            if ($(this).is(':checked')) {
                // Uncheck all other product type filters
                $('input[name="filter.p.m.custom.filter_product_type"]')
                    .not(this)
                    .prop('checked', false)
                    .trigger('change');
            }
        },
    );

    // Accordion functionality
    $(document).on('click', '.collection-filter__accordion-header', function (e) {
        e.preventDefault();
        const $accordion = $(this).closest('.collection-filter__accordion');
        const $content = $accordion.find('.collection-filter__accordion-content');

        // Toggle current accordion
        const isActive = $content.hasClass('is-active');

        // Close all other accordions
        $('.collection-filter__accordion-content')
            .not($content)
            .removeClass('is-active')
            .slideUp();
        $('.collection-filter__accordion-header')
            .not($(this))
            .removeClass('is-active');

        // Toggle current
        if (isActive) {
            $content.removeClass('is-active').slideUp();
            $(this).removeClass('is-active');
        } else {
            $content.addClass('is-active').slideDown();
            $(this).addClass('is-active');
        }
    });
});

class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounceFacets((event) => {
            this.onSubmitHandler(event);
        }, 500);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state
                ? event.state.searchParams
                : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById(
            'ProductCountDesktop',
        );
        document.body.classList.add('sa-facets--loading');

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
                : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [
                    ...FacetFiltersForm.filterData,
                    { html, url },
                ];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const productGridContainer = document.getElementById(
            'product-grid-container',
        );
        const parsedProductGrid = parsedHTML.getElementById(
            'product-grid-container',
        );
        if (productGridContainer && parsedProductGrid) {
            productGridContainer.innerHTML = parsedProductGrid.innerHTML;
        }

        const collectionFilterTabs = document.querySelector(
            '.collection-filter-tabs',
        );
        const parsedFilterTabs = parsedHTML.querySelector(
            '.collection-filter-tabs',
        );
        if (collectionFilterTabs && parsedFilterTabs) {
            collectionFilterTabs.innerHTML = parsedFilterTabs.innerHTML;
        }

        document.body.classList.remove('sa-facets--loading');

        if (window.indentGridProducts) {
            indentGridProducts();
        }
    }

    static renderProductCount(html) {
        const count = new DOMParser()
            .parseFromString(html, 'text/html')
            ?.getElementById('ProductCount')?.innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;

        $('.js-filters-count').html(count);

        document.body.classList.remove('sa-facets--loading');

        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            document.body.classList.remove('sa-facets--loading');
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements = parsedHTML.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #CollectionFilterTabsForm .js-filter',
        );
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter
                ? element.dataset.index === jsFilter.dataset.index
                : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter(
            (element) => !matchesIndex(element),
        );
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            const targetElement = document.querySelector(
                `.js-filter[data-index="${element.dataset.index}"]`,
            );

            if (targetElement) {
                targetElement.innerHTML = element.innerHTML;
                targetElement.classList.remove('active');
            }

            window?.initFiltersSwiper?.();
            const filtersCount = $('.filters-popup input:checked').length;

            $('.js-filters-applied').text(
                filtersCount > 0 ? `(${filtersCount})` : '',
            );
            $('.js-filters-applied-popup').text(
                filtersCount > 0 ? `${filtersCount} Filters` : 'Filters',
            );
            if (filtersCount === 1) {
                $('.js-filters-applied-popup').text(`${filtersCount} Filter`);
            }
            $(
                '.applied-count, .collection-filter-tabs__filters-btn--remove',
            ).toggleClass('active', filtersCount > 0);
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender)
            FacetFiltersForm.renderCounts(
                countsToRender,
                event.target.closest('.js-filter'),
            );
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = [
            '.active-facets-mobile',
            '.active-facets-desktop',
        ];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML =
                activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = [
            '.mobile-facets__open',
            '.mobile-facets__count',
            '.sorting',
        ];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML =
                html.querySelector(selector).innerHTML;
        });

        document
            .getElementById('FacetFiltersFormMobile')
            ?.closest('menu-drawer')
            .bindEvents();
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
            target.querySelector('.facets__selected').outerHTML =
                source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector('.facets__summary').outerHTML =
                source.querySelector('.facets__summary').outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState(
            { searchParams },
            '',
            `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
        );
    }

    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            },
            {
                section: document.querySelector('.collection-filter-tabs').dataset
                    .sectionId,
            },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        const params = new URLSearchParams();

        for (let [key, value] of formData.entries()) {
            // Only add non-empty values
            if (value && value.trim() !== '') {
                params.append(key, value);
            }
        }

        return params.toString();
    }

    createCombinedSearchParams(forms) {
        const allParams = new URLSearchParams();
        const processedKeys = new Set();

        forms.forEach((form) => {
            const formData = new FormData(form);

            for (let [key, value] of formData.entries()) {
                // Skip empty values
                if (!value || value.trim() === '') {
                    continue;
                }

                // For product type filters, only add if not already processed
                if (key === 'filter.p.m.custom.filter_product_type') {
                    if (!processedKeys.has(`${key}:${value}`)) {
                        allParams.append(key, value);
                        processedKeys.add(`${key}:${value}`);
                    }
                } else {
                    // For other parameters, add normally
                    allParams.append(key, value);
                }
            }
        });

        return allParams.toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();

        // Determine which form triggered the event
        const triggeringForm = event.target.closest('form');

        // Handle mobile facets checkbox separately
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(triggeringForm);
            this.onSubmitForm(searchParams, event);
            return;
        }

        // Handle product type filters from tabs or popup form
        if (
            triggeringForm.id === 'CollectionFilterTabsForm' ||
            triggeringForm.id === 'FacetFiltersForm'
        ) {
            // Only use the form that was actually interacted with
            const searchParams = this.createSearchParams(triggeringForm);
            this.onSubmitForm(searchParams, event);
            return;
        }

        // For other cases (sort, mobile, etc.), combine relevant forms
        const forms = [];
        const isMobile = triggeringForm.id === 'FacetFiltersFormMobile';
        const sortFilterForms = document.querySelectorAll(
            'facet-filters-form form',
        );

        sortFilterForms.forEach((form) => {
            if (!isMobile) {
                if (form.id === 'FacetSortForm' || form.id === 'FacetSortDrawerForm') {
                    const noJsElements = document.querySelectorAll('.no-js-list');
                    noJsElements.forEach((el) => el.remove());
                    forms.push(form);
                }
            } else if (form.id === 'FacetFiltersFormMobile') {
                forms.push(form);
            }
        });

        const searchParams = this.createCombinedSearchParams(forms);
        this.onSubmitForm(searchParams, event);
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf('?') == -1
                ? ''
                : event.currentTarget.href.slice(
                    event.currentTarget.href.indexOf('?') + 1,
                );
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((element) => {
            element.addEventListener('change', this.onRangeChange.bind(this));
            element.addEventListener('keydown', this.onKeyDown.bind(this));
        });
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    onKeyDown(event) {
        if (event.metaKey) return;

        const pattern =
            /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
        if (!event.key.match(pattern)) event.preventDefault();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('data-min', 0);
        if (maxInput.value === '')
            minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('data-min'));
        const max = Number(input.getAttribute('data-max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form =
            this.closest('facet-filters-form') ||
            document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}

customElements.define('facet-remove', FacetRemove);

// $('.js-filter-count').html( $('#ProductCount').html() );
